<!-- 特价单详情 -->
<template>
  <div class="rfq-inquiry-list p5 m5 bw br5" :key="pageKey">
    <span>
      <div>
        <div class="block-item poi fix" @click="isShowBlock1 = !isShowBlock1">
          <span class="block-item-title">基本信息</span>
          <q-icon name="fas fa-angle-down" color="blue-grey-2" v-if="isShowBlock1"/>
          <q-icon name="fas fa-angle-up" color="blue-grey-2" v-else/>
        </div>
        <div>
          <base-form :formSet="{data:this.formSet}" :isShowBlock="isShowBlock1"/>
        </div>
      </div>
      <div>
        <div class="block-item poi fix">
          <span class="block-item-title">金额信息</span>
        </div>
        <div>
          <base-form :formSet="{data:this.formSet2}"/>
        </div>
      </div>
      <div>
        <div class="block-item poi fix">
          <span class="block-item-title">单据明细</span>
        </div>
        <div>
            <q-skeleton :height="tableSet.height" v-if="tableSet.loading" />
            <base-table :key="tableKey" v-else></base-table>
        </div>
      </div>
      <ok-dialog ref="okDialog" @handleOK="handleOKFun" :msg="'是否确认？'"></ok-dialog>
    </span>
  </div>
</template>

<script>
import BaseForm from '@/components/pieces/form/row-col-base2.vue';

import BaseTable from '@/components/pieces/tables/edit-table.vue';
import okDialog from '@/components/pieces/dialog/del-dialog';
import {useStore} from "vuex";
import {computed, nextTick, onMounted, ref, watch} from 'vue';
import {getRandomString,isEmpty} from '@/tools/utils';
import { tableHeight } from "@/tools/lines.js";
import {useRoute} from "vue-router";
import {DEFAULT_NOVAlUE_ROW} from "@/tools/common-rfq.js";
import {checkPermission} from '@/tools/permission.js'
export default {
  name: "inquirySheet",
  components:{ BaseForm,BaseTable,okDialog},
  provide(){
    return {
      formSet:{data:this.formSet},
      baseData:this.baseData,
      tableSource:this.tableSet,
      madData:this.madData
    }
  },
  setup(){
    const store = useStore();
    const route =  useRoute();
    let tableKey = ref(getRandomString(8));
    let pageKey = ref(getRandomString(8));
    let key = ref('');//当前页面跳转的key
    let routerParams= ref({});//当前页面携带参数
    let formSet = store.getters['specialOfferDetails/getFormSet'];//表单配置
    let formSet2 = store.getters['specialOfferDetails/getFormSet2'];//表单配置
    let baseData = store.getters['specialOfferDetails/getBaseData'];
    let tableSet = computed(() => store.getters['specialOfferDetails/getTableSet']);
    let madData = computed(() => store.getters['madValueSet/getMadData']);
    let okDialog = ref();
    let isShowBlock1 = ref(false);
    let isShowBlock2 = ref(false);
    let isShowBlock3 = ref(true);

    watch(()=>route,(v)=>{
      initPage();

      // if(!isEmpty(v?.query?.key) && key.value !== v.query.key && route.path == '/rfq/confirmation-sheet'){
      //   let params = JSON.parse(localStorage.getItem(v?.query?.key));
      //   key.value = v.query.key;
      //   routerParams.value = params;
      //   store.commit('specialOfferDetails/clearData');
      //   initPage();
      //   if(isEmpty(params)){
      //     key.value = '';
      //   }else{
      //     init();
      //   }
      //   nextTick(()=>{
      //     localStorage.removeItem(v?.query?.key);
      //   })
      // }
    }, {
      deep:true,
      immediate:true
    });
    function initPage(){
      refreshTableHeight();
      window.onresize = () => {
        return (() => {
          refreshTableHeight();
        })();
      };
    }
    //进入页面填满整个表格
    function fullTable(){
      let cellHeight = 28;
      let tableHeight = tableSet.value.height.split('px')[0];
      tableHeight = Number(tableHeight) - 140
      let rowNumber =Math.ceil(Number(tableHeight)/ cellHeight);
      let newRowNuber =  rowNumber - tableSet.value.data.length;
      for(let i=0 ; i < newRowNuber ;i++){
        addRow();
      }
    }
    //新增行数据
    function addRow(){
      let rowData =JSON.parse(JSON.stringify(DEFAULT_NOVAlUE_ROW));
      store.commit('specialOfferDetails/addRow',rowData);
    }
    async function init(){
      // try{
      //   let data = await store.dispatch('specialOfferDetails/getHeader',routerParams.value.rowData);
      //   store.dispatch('specialOfferDetails/getList',data).then(()=>{
      //     fullTable();
      //   });
      // }catch (e) {
      //   console.log(e);
      // }
      // nextTick(()=>{
      //   pageKey.value =getRandomString(8);
      // })
    }
    function handleOKFun(){
      try{
        store.dispatch('specialOfferDetails/confirmationOk').then((data)=>{
          store.dispatch('response/success-tip', { message: '生成确认单！' });
          init();
        }).catch((error)=>{
          store.dispatch("response/set-api-response", {...error,errorMessage:'生成确认单失败'});
        })
      }catch (e) {
        console.log(e);
      }
    }
    function handleOk(){
      if(!(checkPermission('change_quotation2') && checkPermission('change_quotationentry2'))){
        store.dispatch("response/error-tip", {message: "您没有执行权限",});
        return
      }
      okDialog.value.setStatus();
    }
    /**
     * 刷新表格高度
     */
    function refreshTableHeight() {
      store.commit("specialOfferDetails/refreshTableHeight", tableHeight()-110);
    }
    return{
      tableKey,
      tableSet,
      formSet,
      okDialog,
      handleOKFun,
      baseData,
      handleOk,
      pageKey,
      madData,
      key,
      formSet2,
      isShowBlock1,
      isShowBlock2,
      isShowBlock3
    }
  },
}
</script>

<style scoped lang="scss">

.rfq-inquiry-list{
  .header-style{
    border-bottom: 2px solid #EEEEEE;
    font-size: 16px;
    font-weight: 600;
    .header-style-title{
      color:#42A5F5;
    }
  }
}
.bw{
  background-color: white;
}
.p10{
  padding: 10px;
}
.pt10{
  padding-top: 10px;
}
.p5{
  padding: 5px;
}
.m5{
  margin: 5px;
}
.mb5{
  margin-bottom: 5px;
}
.br5{
  border-radius: 5px;
}
.l {
  float: left;
}
.r {
  float: right;
}
.fix{*zoom:1;}
.fix:after{display:table; content:''; clear:both;}
.my-text-btn:hover{
  color: #42A5F5;
}
</style>



